module.exports = __webpack_public_path__ + "39f9ef4e1d8858e03a815914b2e5989d.svg";